export const getGameRoomTimeDetails = ({
  entryOpenTime,
  entryCloseTime,
  gameStartTime,
  gameEndTime,
}) => {
  const entryOpeningAt = new Date(entryOpenTime)
  const entryClosingAt = new Date(entryCloseTime)
  const gameStartAt = new Date(gameStartTime)
  const gameCloseAt = new Date(gameEndTime)

  let gameRooomTimeDetail = {
    roomStatus: '',
    targetTime: new Date(),
  }

  const now = new Date()

  if (now < entryOpeningAt) {
    gameRooomTimeDetail = {
      roomStatus: 'upComing',
      targetTime: entryOpeningAt,
    }
  } else if (now >= entryOpeningAt && now < entryClosingAt) {
    gameRooomTimeDetail = {
      roomStatus: 'entryOpened',
      targetTime: entryClosingAt,
    }
  } else if (now >= entryClosingAt && now < gameStartAt) {
    gameRooomTimeDetail = {
      roomStatus: 'entryClosed',
      targetTime: gameStartAt,
    }
  } else if (now >= gameStartAt && now < gameCloseAt) {
    gameRooomTimeDetail = {
      roomStatus: 'live',
      targetTime: gameCloseAt,
    }
  } else {
    gameRooomTimeDetail = {
      roomStatus: 'closed',
      targetTime: new Date(),
    }
  }

  return gameRooomTimeDetail
}
